import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Typography, Paper, Button, Select, MenuItem } from '@mui/material';
import { Bell, CheckCircle2 } from 'lucide-react';
import './NotificationsPage.css';

import Footer from '../commun/Footer';
import HeaderEntreprise from '../header/headerEntreprise';
import HeaderRecruteur from '../header/headerRec';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [userType, setUserType] = useState(null);

  const pageSize = 10;

  useEffect(() => {
    setUserType(localStorage.getItem('userType')?.toLowerCase());
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await axios.get(`${API_BASE}/api/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(res.data);
    } catch (error) {
      console.error('Erreur récupération notifications :', error.message);
    }
  };

  const markAsRead = async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      await axios.put(`${API_BASE}/api/notifications/${id}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Erreur mise à jour :', error.message);
    }
  };

  const markAllAsRead = async () => {
    try {
      const token = localStorage.getItem('authToken');
      await axios.put(`${API_BASE}/api/notifications/mark-all-read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (err) {
      console.error('Erreur marquer tout lu:', err);
    }
  };

  const filtered = notifications.filter(n =>
    filter === 'all' ? true : filter === 'unread' ? !n.isRead : n.isRead
  );

  const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));

  return (
    <>
      {userType === 'entreprise' && <HeaderEntreprise />}
      {userType === 'recruteur' && <HeaderRecruteur />}

      <div className="notif-container">
        <div className="notif-header">
          <Typography variant="h5" className="notif-title">📥 Toutes mes notifications</Typography>
          <div className="notif-actions">
            <Select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="notif-filter"
            >
              <MenuItem value="all">Toutes</MenuItem>
              <MenuItem value="unread">Non lues</MenuItem>
              <MenuItem value="read">Lues</MenuItem>
            </Select>
            <Button variant="contained" className="mark-all" onClick={markAllAsRead}>
              Tout marquer comme lu
            </Button>
          </div>
        </div>

        <div className="notif-list">
          {paginated.length === 0 ? (
            <Typography className="empty-message">Aucune notification</Typography>
          ) : (
            paginated.map((notif) => (
              <Paper
                key={notif._id}
                className={`notif-card ${notif.isRead ? 'read' : 'unread'}`}
                onClick={() => markAsRead(notif._id)}
              >
                <div className="notif-icon">
                  {notif.isRead ? <CheckCircle2 size={20} /> : <Bell size={20} />}
                </div>
                <div className="notif-content">
                  <Typography variant="body1">{notif.message}</Typography>
                  <Typography variant="caption" className="notif-date">
                    {notif.createdAt
                      ? new Date(notif.createdAt).toLocaleString('fr-FR', {
                          day: '2-digit', month: '2-digit', year: 'numeric',
                          hour: '2-digit', minute: '2-digit'
                        })
                      : 'Date inconnue'}
                  </Typography>
                </div>
              </Paper>
            ))
          )}
        </div>

        <div className="notif-pagination">
          <Button disabled={page === 1} onClick={() => setPage(page - 1)}>Précédent</Button>
          <Typography className="pagination-info">{page} / {totalPages}</Typography>
          <Button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Suivant</Button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NotificationsPage;
